/**
 * Animation Style Utilities
 *
 * Shared animation styles for floating components (Popover, Dropdown, Tooltip, Dialog).
 * These patterns are used consistently across all floating UI components.
 */

/**
 * Base fade animation for open/close states
 */
export const FADE_ANIMATION =
  'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0';

/**
 * Zoom animation for scale transitions
 */
export const ZOOM_ANIMATION =
  'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95';

/**
 * Combined fade + zoom animation
 * Used for dialogs and floating content
 */
export const FADE_ZOOM_ANIMATION = `${FADE_ANIMATION} ${ZOOM_ANIMATION}`;

/**
 * Slide animation based on placement side
 * Used for popovers, dropdowns, and tooltips
 */
export const SLIDE_FROM_SIDE_ANIMATION =
  'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2';

/**
 * Complete floating content animation
 * Combines fade, zoom, and slide animations
 * Used for: Popover, DropdownMenu, Tooltip, Select content
 */
export const FLOATING_CONTENT_ANIMATION = `${FADE_ZOOM_ANIMATION} ${SLIDE_FROM_SIDE_ANIMATION}`;
